import React from 'react'
import { Route } from 'react-router'
const MyAccount = React.lazy(() => import('@/modules/my-account/my-account'))

const myAccountRoutes = (
  <Route path='my-account' Component={MyAccount} />
)

export default myAccountRoutes
